import { render, staticRenderFns } from "./PastSession.vue?vue&type=template&id=861b247a&scoped=true&"
import script from "./PastSession.vue?vue&type=script&lang=js&"
export * from "./PastSession.vue?vue&type=script&lang=js&"
import style0 from "./PastSession.vue?vue&type=style&index=0&id=861b247a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "861b247a",
  null
  
)

export default component.exports